import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withStyles } from '@material-ui/core'
import {
  CreateCertificate,
  Selections,
  AccordionPart,
  SuccessRate,
  CertificateEdit,
  Highlights,
  PaymentSetup,
} from './components'
import styles from './styles'
import { getCertificateAction } from 'src/reducers/certificate/action'
import IsActive from './components/is-active'
import UpgradeCertificate from 'src/components/upgrade-certificate'
import UserType from 'src/model/user-types'
import { getCollectionLandingPageAction } from 'src/reducers/collection/action'
const Certification = props => {
  const { classes, logoUrl, setLogoUrl } = props

  const dispatch = useDispatch()

  const certificateParent = useSelector(state => state.certificate)
  const certificate = certificateParent.certificate
  const collection = useSelector(state => state.collection.collection)
  const [certificateExist, setCertificateExist] = useState(false)
  const [certificateType, setCertificateType] = useState(0)

  useEffect(() => {
    dispatch(getCollectionLandingPageAction(collection.id))
  }, [collection.id])
  //const [certificate, setCertificate] = useState(0)

  useEffect(() => {
    dispatch(
      getCertificateAction(collection.id, response => {
        //setCertificate(response)
        setCertificateType(response.type)
        setCertificateExist(response != null ? true : false)
      }),
    )
  }, [])

  if (!UserType.hasCertifications(Number(window?.CONSTANTS.USER_ROLE_ID))) {
    return (
      <div className={classes.container}>
        <UpgradeCertificate />
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {certificateExist ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <IsActive />
          <Selections
            certificate={certificate}
            certificateType={certificateType}
            setCertificateType={setCertificateType}
          />
          {certificateType === 1 && <SuccessRate />}
          <AccordionPart certificateType={certificateType} />
          <CertificateEdit logoUrl={logoUrl} />
          <Highlights
            logoUrl={logoUrl}
            setLogoUrl={setLogoUrl}
            certificate={certificate}
          />
          <PaymentSetup />
        </div>
      ) : (
        <CreateCertificate setCertificateExist={setCertificateExist} />
      )}
    </div>
  )
}

export default withStyles(styles)(Certification)
